import { FC } from "react";

import { JourneyRouteManager } from "modules/managers/JourneyRouteManager";

const JourneyLayout: FC = () => <JourneyRouteManager />;

export default JourneyLayout;
